<template>
  <div>Liveclass under development
    <div id="live-class" class="footer-hidden m-0 p-0">
      <div v-if="liveError.isError"
        class="vx-row lg:h-full flex m-0 relative bg-black mr-2 px-20 py-32"
      >
        <div
          class="vx-col panel h-screen lg:h-full sm:h-1/2 flex-1 sm:w-1/1 p-0
            flex flex-col flex-wrap items-center justify-center
          "
        >
          <h3 class="text-danger text-center mt-20">Live is not available right now</h3>
          <div class="flex justify-center flex-wrap mt-32">
            <!-- <vs-button class="mx-2" @click="routeTo('/')">Back to home</vs-button>
            <vs-button class="mx-2" @click="routeTo('/liveschedule')">View other Live Class</vs-button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, vue/no-unused-components */

export default {
  components: {
  },
  data() {
    return {
      liveError: {
        isError: true,
        nolive: true,
      },
    }
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {
    routeTo(route) {
      if (route) {
        this.$router.push(route);
      }
    },
  }
}
</script>

<style lang="scss">

</style>